import { Component, OnInit, AfterViewInit, ChangeDetectorRef, InjectionToken, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { AclDialogComponent } from 'app/modules/shared/components';
import { HTTPService, ACLService, HelperService, ValidationService, GeoLocationService } from 'app/services';
import { messages } from 'app/constants';
import { SubscriptionWelcomeModalComponent } from '../subscription-welcome-modal/subscription-welcome-modal.component';

import { environment } from 'environments/environment';

import { trim } from 'lodash';
import { CookieService } from 'ngx-cookie';
import { ScriptLoaderService } from 'app/services/script-loader.service';
import { setLanguagePreferences } from 'app/constants/language-translate';

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window,
});

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [DialogService],
})
export class LoginComponent implements OnInit, AfterViewInit {
  declare OneSignal: any;

  user = { userName: '', password: '', info: {} };
  validate: any = {};
  navigation: any;
  state: any = null;
  isPasswordFloating: boolean = false;
  token: any = null;
  isLoading: boolean = false;
  isAutoLoggingIn: boolean = false;
  hasShowPasswordIcon: boolean = false;

  constructor(
    private httpService: HTTPService,
    private aclService: ACLService,
    private helperService: HelperService,
    private cookieService: CookieService,
    private router: Router,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private scriptLoader: ScriptLoaderService,
    private validationService: ValidationService,
    private geoLocationService: GeoLocationService,
    @Inject(WINDOW) private window: Window,
  ) {
    //  // retrieve token from cookie
    //  this.token = this.cookieService.getObject('alpat');

    //  // if token exists navigate to entry point
    //  if (this.token) {
    //    const { role } = this.helperService.getCompany();
    //    this.router.navigate([this.aclService.getEntry(role)]);
    //    // this.handleRedirection(this.token);
    //  }

    //  // for using nav extras
    //  this.navigation = this.router.getCurrentNavigation();
    try {
      this.token = this.cookieService.getObject('alpat');

      try {
        if (this.activatedRoute.snapshot.queryParamMap.get('token')) this.token = '';
      } catch (err) {
        console.log(err);
      }

      // if token exists navigate to entry point
      if (this.token) {
        const { role } = this.helperService.jwtDecode(this.token);
        this.router.navigate([this.aclService.getEntry(role)]);
      }

      // for using nav extras
      this.navigation = this.router.getCurrentNavigation();
    } catch (err) {
      console.log(err);
    }
  }

  async ngOnInit() {
    if (this.navigation.extras.state) {
      // destruct error message and set into view
      this.state = this.navigation.extras.state as {
        errorMessage: string;
      };

      if (this.navigation.extras.state.userName) {
        this.user.userName = this.navigation.extras.state.userName;
      }
    }

    const { queryParamMap } = this.activatedRoute.snapshot;
    const token = queryParamMap.get('token');
    const isRecentRoleChange = queryParamMap.get('recentRoleChange');
    const isFirstLogin = queryParamMap.get('isFirstLogin');
    const isNeededClockIn = queryParamMap.get('isNeededClockIn');
    const errorMessage = queryParamMap.get('errorMessage');
    const isTech = queryParamMap.get('isTech') === 'true';

    if (errorMessage) {
      this.state = { errorMessage };
    }

    if (token) {
      this.token = token;
      this.setLoginSetting({ token, isRecentRoleChange, isFirstLogin, isNeededClockIn, isTech, refetchToken: true });
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  async setLoginSetting({ token, isRecentRoleChange, isFirstLogin, isNeededClockIn, isTech, refetchToken }) {
    // set token in cookie
    if (refetchToken) {
      try {
        token = await this.httpService.updateSession(token);
      } catch (err) {
        this.helperService.showToaster('error', err);
      }
    }
    const cookieOptions = environment.cookieOption as any;

    if (isTech) {
      cookieOptions.expires = new Date(new Date().setHours(23, 59));
    }

    this.cookieService.putObject('alpat', token, cookieOptions);
    this.setPlayerId();

    // track for recent role change and show Role change dialog
    if (isRecentRoleChange === 'true') {
      this.openRoleChangeDialog();
    }

    // if this is first time guided trial login, open welcome dialog
    if (isFirstLogin === 'true') {
      this.openGuidedTrialFirstLoginDialog();
    }

    // if tech is not clocked in then navigate to clock screen
    if (isNeededClockIn === 'true') {
      this.router.navigate(['/tech/clock']);
      return;
    }

    // navigate to entry point
    // this.router.navigate([this.aclService.getEntry(this.helperService.jwtDecode(token).role)]);
    this.handleRedirection(token);
  }

  handleRedirection(token: string) {
    const { role, isWorkAsTechEnabled } = this.helperService.jwtDecode(token);
    if (['admin', 'serviceWriter'].includes(role) && isWorkAsTechEnabled && this.helperService.isMobileOrTablet()) {
      this.router.navigate(['/tech/clock']);
      return;
    }

    this.router.navigate([this.aclService.getEntry(this.helperService.jwtDecode(token).role)]);
  }

  setPlayerId() {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this.scriptLoader.loadScript('OneSignal');
        console.log('script loading done');
        // alert('script loading done');
        const { OneSignal } = window as any;
        console.log('One Signal', OneSignal);
        // alert(OneSignal ? 'yes' : 'no');
        if (!OneSignal) {
          setTimeout(async () => {
            try {
              const playerId = await OneSignal.getUserId();
              await this.httpService.setNotificationPlayerId(playerId);
              console.log(playerId);
              alert(playerId);
            } catch (err) {
              console.log(err);
            }
          }, 1000);
          const playerId = await OneSignal.getUserId();

          // alert(playerId);

          resolve();
        }
        // const { OneSignal } = this.window as any;
      } catch (err) {
        console.log(err);
        resolve();
      }
    });
  }

  onFocus(name) {
    this.validate[name] = '';

    if (name === 'password') this.isPasswordFloating = true;
  }

  onChange(name, value) {
    this.user[name] = value;
    if (name === 'userName') {
      const userName = this.user[name];
      if (this.validationService.isAlSupportEmail(userName) || !trim(userName)) {
        this.hasShowPasswordIcon = false;
      } else if (userName) {
        this.hasShowPasswordIcon = true;
      }
    }
  }

  forgotPassword() {
    this.router.navigate(['../forgot-password']);
  }

  validateForm() {
    let isValid = true;
    this.validate = {};
    // trimming email
    this.user.userName = this.user.userName.trim();
    if (!this.user.userName) {
      this.validate.userName = messages.enterUsername;
      isValid = false;
    }

    if (!this.user.password) {
      this.validate.password = messages.enterPassword;
      isValid = false;
    }

    return isValid;
  }

  onSubmit() {
    if (this.validateForm()) {
      this.isLoading = true;
      this.httpService.login(this.user).then(
        (res) => {
          // If the user has already set the strong password then redirect to the appropriate page.
          if (res?.hasStrongPassword || !res?.isPasswordValidatonEnabled) {
            if (environment.site && res.site && environment.site !== res.site) {
              let url = `${environment.app2_base_url}#/login?token=${res.token}&recentRoleChange=${res.recentRoleChange}&isFirstLogin=${res.isFirstLogin}&isTech=${res.employee?.role === 'tech'}`;

              if (res.employee && res.employee.role === 'tech' && !res.employee.clockedIn) {
                url += `&isNeededClockIn=true`;
              }

              window.location.replace(url);
              return;
            }

            // record login activity
            this.geoLocationService.getGeoInfo().then((info: any) => {
              this.httpService.recordLoginActivity(info).catch((err) => console.error(err));
            });
            this.setLoginSetting({
              token: res.token,
              isRecentRoleChange: res.recentRoleChange,
              isFirstLogin: res.isFirstLogin,
              isNeededClockIn: res.employee && res.employee.role === 'tech' && !res.employee.clockedIn,
              isTech: res.employee?.role === 'tech',
              refetchToken: false,
            });
            setLanguagePreferences('en', res.companyLocalization, res.companyPreferredLanguage);
          } else {
            // If the password is not strong, redirect the user to the set-password page.
            this.router.navigate([`../set-password/${res.token}`]);
            return;
          }
        },
        (error) => {
          this.isLoading = false;
          this.validate.password = error;
        },
      );
    }
  }

  openGuidedTrialFirstLoginDialog() {
    this.dialogService.open(SubscriptionWelcomeModalComponent, {
      width: '500px',
      styleClass: 'small-heading-dialog',
      showHeader: false,
    });
  }

  openRoleChangeDialog() {
    const title = `Your User role was recently updated`;
    const subTitle = `Your User role was recently updated. Contact your administer for more information`;
    this.dialogService.open(AclDialogComponent, {
      width: '500px',
      styleClass: 'small-heading-dialog',
      data: { title, subTitle },
      showHeader: false,
    });
  }
}
